import { readAppConfig } from "./appConfig.js";

function readImportMetaEnv() {
  return typeof import.meta !== "undefined" ? import.meta.env || {} : {};
}

function readProcessEnv() {
  return typeof process !== "undefined" ? process.env || {} : {};
}

export const appConfig = readAppConfig({
  ...readProcessEnv(),
  ...readImportMetaEnv()
});

export const serviceName = appConfig.serviceName;
export const serviceSlug = appConfig.serviceSlug;
export const fallbackPublicSiteOrigin = appConfig.publicSiteOrigin;
export const walletAuthStatement = appConfig.walletAuthStatement;
export const trustedTypesPolicyName = appConfig.trustedTypesPolicyName;
export const serviceXHandle = appConfig.serviceXHandle;
export const serviceXProfileUrl = appConfig.serviceXProfileUrl;

export function buildDefaultAppIdentity(origin = fallbackPublicSiteOrigin) {
  return {
    name: serviceName,
    uri: origin,
    icon: `${origin}/favicon.svg`
  };
}
